export var PASSWORD_ERROR_MESSAGE;
(function (PASSWORD_ERROR_MESSAGE) {
    PASSWORD_ERROR_MESSAGE["UPPERCASE_MISSING"] = "Le mot de passe doit contenir au moins une majuscule";
    PASSWORD_ERROR_MESSAGE["SPECIAL_CHAR_MISSING"] = "Le mot de passe doit contenir au moins un caract\u00E8re sp\u00E9cial";
})(PASSWORD_ERROR_MESSAGE || (PASSWORD_ERROR_MESSAGE = {}));
export const upCase = (value) => {
    if (value.match(/[A-Z]/g) !== null) {
        return true;
    }
    return PASSWORD_ERROR_MESSAGE.UPPERCASE_MISSING;
};
export const specialChar = (value) => {
    // Based on https://desgeeksetdeslettres.com/cybersecurite/caracteres-speciaux-pour-mots-de-passe
    // Si ce n'est ni une minuscule, ni une majuscule, ni un chiffre alors c'est un caractère spécial (ce qui inclut les caractères accentués, cédilles, etc.)
    if (value && value.match(/[^a-zA-Z0-9]/g) !== null) {
        return true;
    }
    return PASSWORD_ERROR_MESSAGE.SPECIAL_CHAR_MISSING;
};
